var map = {
	"./ar/label.json": 8479,
	"./cz/label.json": 2457,
	"./de/label.json": 3367,
	"./en/label.json": 3487,
	"./es/label.json": 5824,
	"./fr/label.json": 3864,
	"./hr/label.json": 3850,
	"./ja/label.json": 3069,
	"./ko/label.json": 8482,
	"./kz/label.json": 9374,
	"./pt/label.json": 8488,
	"./sh/label.json": 1851,
	"./sr/label.json": 9249,
	"./sv/label.json": 2125
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9675;